import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import LoadingSpinner from '../../components/UI/LoadingSpinner';

// Reset-password: reached from the emailed link (?token=...). User sets a new
// password; on success they're sent to /login.
const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/auth/reset-password', { token, newPassword: password });
      toast.success('Password reset. Please sign in.');
      setDone(true);
      setTimeout(() => navigate('/login'), 1500);
    } catch (error) {
      toast.error(error.response?.data?.message || 'This reset link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-6 text-center">
          <p className="text-gray-800 font-medium mb-2">Invalid reset link</p>
          <p className="text-sm text-gray-600 mb-4">This link is missing its token. Please request a new one.</p>
          <Link to="/forgot-password" className="font-medium text-blue-600 hover:text-blue-500">Request a new link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Choose a new password</h2>
        {done ? (
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <p className="text-gray-800 font-medium">Password updated.</p>
            <p className="text-sm text-gray-600 mt-1">Redirecting you to sign in…</p>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="password" className="form-label">New password</label>
              <input
                id="password" name="password" type="password" autoComplete="new-password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="form-input" placeholder="At least 8 characters"
              />
            </div>
            <div>
              <label htmlFor="confirm" className="form-label">Confirm new password</label>
              <input
                id="confirm" name="confirm" type="password" autoComplete="new-password" required
                value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="form-input" placeholder="Re-enter password"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full flex justify-center">
              {loading ? <LoadingSpinner size="sm" /> : 'Reset password'}
            </button>
            <p className="text-center text-sm text-gray-600">
              <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
